import { Button } from "@mui/material";
import icon_male from '../images/icon/avatar-boy.png'
import icon_female from '../images/icon/avatar-girl.png'
import { useSelector } from "react-redux";
import { RootState } from "../redux";
import { ProfileStudent } from "../Utils/DataType";
import ManageAccountsRoundedIcon from '@mui/icons-material/ManageAccountsRounded';
import PasswordRoundedIcon from '@mui/icons-material/PasswordRounded';
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import { useState } from "react";
import DialogProfile from "./DialogProfile";
import ChangePassword from "./ChangePassword";

export default function AccountOption() {
    let profile = useSelector<RootState, ProfileStudent>(state => state.profile);
    const [show, setShow] = useState<boolean>(false);
    const [showDialog, setShowDialog] = useState<boolean>(false);
    const [showPopupPassword, setShowPopupPassword] = useState<boolean>(false);

    return (
        <>
            <ChangePassword show={showPopupPassword} setShow={setShowPopupPassword} />
            <DialogProfile show={showDialog} setShow={setShowDialog} />
            <div className="account-option "
                onMouseEnter={() => setShow(true)}
                onMouseLeave={() => setShow(false)}>
                <Button
                    className="account-option--button"
                    sx={{ backgroundColor: 'transparent', color: 'transparent', textTransform: 'none', fontFamily: '"Nunito Sans", sans-serif', width: '15rem' }}

                >
                    <div className="flex gap-2 items-center">
                        <div className="account-option--icon">
                            <img src={icon_male} alt="" />
                        </div>
                        <div className="flex justify-start flex-col">
                            <div className="text-[#757575] text-base font-medium">
                                {`${profile.first_name} ${profile.last_name}`}
                            </div  >
                            <div className="text-[#757575] text-left text-xs font-bold">{`${profile.student_id}`}</div>
                        </div>
                    </div>
                </Button>
                <div className={show ? "account-task account-task__show" : "account-task"}>
                    <Button
                        onClick={() => setShowDialog(true)}
                        startIcon={<ManageAccountsRoundedIcon />}
                        fullWidth
                        sx={{
                            color: '#616161', textTransform: 'none', fontFamily: '"Nunito Sans", sans-serif', fontSize: '1rem', height: '3rem', justifyContent: 'flex-start',
                            '&:hover': { color: '#1e88e5', backgroundColor: '#e1f5fe' }
                        }}>
                        Thông tin cá nhân</Button>
                    <Button
                        onClick={() => setShowPopupPassword(true)}
                        startIcon={<PasswordRoundedIcon />}
                        fullWidth
                        sx={{
                            color: '#616161', textTransform: 'none', fontFamily: '"Nunito Sans", sans-serif', fontSize: '1rem', height: '3rem', justifyContent: 'flex-start',
                            '&:hover': { color: '#1e88e5', backgroundColor: '#e1f5fe' }
                        }}>
                        Đổi mật khẩu</Button>
                    <Button
                        startIcon={< ExitToAppRoundedIcon />}
                        fullWidth
                        sx={{
                            color: '#616161', textTransform: 'none', fontFamily: '"Nunito Sans", sans-serif', fontSize: '1rem', height: '3rem', justifyContent: 'flex-start',
                            '&:hover': { color: '#1e88e5', backgroundColor: '#e1f5fe' }
                        }}>
                        Đăng xuất</Button>
                </div>
            </div>
        </>

    )
}